import React from 'react';

import { ListGroup, ListGroupItemProps } from 'react-bootstrap';
import { ListGroupProps } from 'react-bootstrap/ListGroup';

export interface IPohListItem extends Omit<ListGroupItemProps, 'content'> {
  key: string | number;
  /** @deprecated use children instead content */
  content?: React.ReactNode;
}

export interface IPohListProps extends ListGroupProps {
  flush?: boolean;
  data: IPohListItem[];
  className?: string;
}

const PohList: React.FC<IPohListProps> = ({ data, flush = false, ...opts }) => {
  return (
    <ListGroup variant={flush ? 'flush' : undefined} {...opts}>
      {data.map(({ key, content, children, ...rest }) => (
        <ListGroup.Item key={key} {...rest}>
          {content ?? children}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default PohList;
